export default __webpack_public_path__ + "static/media/menu.69b2ed96.svg";